import React from 'react';
import { Alert } from '../../../CommonComponents/OPL/Alert/Alert';
import { Breakdown } from '../../../FinancialPlanOPL/Goals/pages/AssetBucketingResults/components/Breakdown/Breakdown';
import { useAssetBucketingPreview } from './useAssetBucketingPreview';

export const AssetBucketingPreview = () => {
  const assetBucketingPreview = useAssetBucketingPreview();

  if (!assetBucketingPreview) {
    return null;
  }

  const {
    data: {
      headline,
      supportingText,
      networthAmount,
      networthMakeup,
      buckets,
      isDefaultAssetBucketingLayout,
    },
    actions: { navigateToSettings },
  } = assetBucketingPreview;

  return (
    <div>
      <Alert
        message="This is a preview of the actions page."
        variant="info"
        extraAction={{
          text: 'Return to Settings',
          action: navigateToSettings,
        }}
      />

      <Breakdown
        title={headline}
        description={supportingText}
        networthAmount={networthAmount}
        networthMakeup={networthMakeup}
        buckets={buckets}
        showFullBreakdown={networthAmount > 0}
        isDefaultAssetBucketingLayout={isDefaultAssetBucketingLayout}
      />
    </div>
  );
};
